import { ExportOutlined } from "@ant-design/icons";
import { privilegeLink } from "@p0security/shared/assessment/render";
import { ProviderOrAll } from "@p0security/shared/types/assessment";
import { Flex, Typography } from "@p0security/ui";
import { GraphTooltip } from "components/GraphTooltip";

import { LinkDetailsSpan, LinkNameSpan } from "./LinkDiv";

/** Renders a link to the IAM Risk Catalog for a privilege
 *
 * If the privilege is remediated by currently selected recommendations,
 * will render struck-through.
 */
export const PrivilegeLink: React.FC<{
  privilege: string;
  provider: ProviderOrAll;
}> = ({ privilege, provider }) =>
  provider === "all" || provider === "custom" ? (
    <>{privilege}</>
  ) : (
    <Flex align="center" gap="0.125em">
      <GraphTooltip title={privilege}>
        <LinkNameSpan>{privilege}</LinkNameSpan>
      </GraphTooltip>
      <LinkDetailsSpan>
        <Typography.Link
          href={privilegeLink(provider, privilege)}
          target="catalog"
        >
          <ExportOutlined />
        </Typography.Link>
      </LinkDetailsSpan>
    </Flex>
  );
